<template>
  <div class="collapse-menu-wrap">
    <menu-title :close="close">{{targetTitle}}</menu-title>
    <menu-item class="menu-item-switch" :label="$t('menu.layout')">
      <!-- 描述 -->
      <menu-switch
        :label="$t('menu.describe')"
        :value="target.descriptionShow"
        @change="(v)=> target.descriptionShow = v"
      ></menu-switch>
    </menu-item>
    <menu-divider />
<!--    <menu-item label="图片" size-tip="(建议比例4:3)">-->
<!--      &lt;!&ndash; 图片 &ndash;&gt;-->
<!--      <menu-background-image-->
<!--        :target="target"-->
<!--        background-blur-disabled-->
<!--        color-disabled-->
<!--        event-key="collapse-img"-->
<!--      />-->
<!--    </menu-item>-->
    <menu-item label="内容版块">
      <div v-for="(item, index) in target.blockList" :key="index + 'block'" class="mb-2">
        <div class="block-item">
          <span>板块{{ index + 1 }}</span>
          <div class="flex justify-center items-center w-[28px] h-[32px] hover:bg-fillColor-2 cursor-pointer" @click="target.blockList.splice(index, 1)">
            <i class="el-icon-delete text-white text-[13px]" />
          </div>
        </div>
        <menu-background-image :target="item.thumbBackground" :target-index="index" target-key="thumbBackground" :event-key="`show-collapse-img-${index}`" />
      </div>
      <menu-button v-if="target.blockList.length < max" type="ghost" icon="add" @click.native="target.__addBlockItem()">添加板块{{ max - target.blockList.length }}/{{ max }}</menu-button>
    </menu-item>
    <delete-block-dialog-trigger class="mt-4" @delete-block="deleteBlock" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import cloneDeep from "lodash.clonedeep";
import menuTitle from '~/components/menu/menuTitle'
import MenuItem from '~/components/menu/menuItem'
import MenuSwitch from '~/components/menu/menuSwitch.vue'
import DeleteBlockDialogTrigger from '~/site/components/editMenu/deleteBlockTrigger'
import MenuDivider from "~/components/menu/divider.vue";
import {insertStep} from "~/utils/event";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue"
import MenuButton from '~/components/menu/menuButton.vue'

export default {
  name: 'EditMenuCollapse',
  components: {
    MenuButton,
    MenuBackgroundImage,
    MenuDivider,
    DeleteBlockDialogTrigger,
    MenuItem,
    MenuSwitch,
    menuTitle
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    childIndex: {
      type: [Number, undefined],
      default() {
        return undefined
      },
    },
  },
  data() {
    return {
      max: 3
    }
  },
  computed: {
    target() {
      return this.model?.__selectChild || {}
    },
    targetTitle() {
      return `${this.$t('menu.collapseRow')}${this.childIndex === undefined ? '' : this.childIndex + 1}`
    },
  },
  methods: {
    ...mapMutations({
      ADD_MENU_KEY: 'menu/ADD_MENU_KEY',
      REMOVE_MENU_KEY: 'menu/REMOVE_MENU_KEY',
    }),
    close() {
      this.SiteMenu.close()
    },
    deleteBlock() {
      insertStep(this, ['children'], cloneDeep(this.model.children))
      this.$store.commit('editor/CLEAR_STORAGE_STEP')
      this.close()
      this.model.deleteMenuMethod()
    },
  }
}
</script>

<style lang="less">
.collapse-menu-wrap {
  .block-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 8px;
    height: 32px;
    background-color: @fill-color-2;
    font-size: 12px;
    color: @text-3;
  }
}
</style>
